<script>
  import { inertia } from '@inertiajs/svelte';
  import Icon from '@iconify/svelte';
  import AppLayout from '../../components/AppLayout.svelte';
  import Card from '../../components/ui/Card.svelte';
  import Button from '../../components/ui/Button.svelte';
  import StatCard from '../../components/ui/StatCard.svelte';
  import PlatformBadge from '../../components/ui/PlatformBadge.svelte';
  import StatusBadge from '../../components/StatusBadge.svelte';

  let {
    social_accounts = [],
    recent_posts = [],
    counts = { accounts: 0, scheduled: 0, published: 0 },
    unfilled_occurrences = [],
  } = $props();

  const stats = [
    { key: 'accounts', label: 'Connected accounts', icon: 'mdi:account-multiple' },
    { key: 'scheduled', label: 'Scheduled', icon: 'mdi:clock-outline' },
    { key: 'published', label: 'Published', icon: 'mdi:check-circle-outline' },
  ];
</script>

<AppLayout title="Dashboard">
  <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
    {#each stats as s}
      <StatCard icon={s.icon} count={counts[s.key]} label={s.label} />
    {/each}
  </div>

  <div class="flex gap-3 mb-8">
    <Button href="/posts/new"><Icon icon="mdi:plus" class="mr-1" /> Compose post</Button>
    <Button href="/social_accounts/new" variant="secondary"><Icon icon="mdi:link-variant" class="mr-1" /> Connect account</Button>
  </div>

  {#if unfilled_occurrences.length > 0}
    <Card title="Needs attention">
      <ul class="flex flex-col divide-y divide-secondary-100">
        {#each unfilled_occurrences as occurrence}
          <li class="py-3 first:pt-0 last:pb-0">
            <a use:inertia href={`/slots/${occurrence.slot_id}`} class="flex items-center justify-between gap-3 group">
              <span class="text-sm text-secondary-700 group-hover:text-primary-700 flex items-center gap-2">
                <Icon icon="mdi:alert-circle-outline" class="text-amber-600" />
                {occurrence.slot_name} — {new Date(occurrence.occurs_at).toLocaleString()}
              </span>
              <span class="text-xs text-secondary-400">{occurrence.mode === 'automatic' ? 'bins empty' : 'needs a post'}</span>
            </a>
          </li>
        {/each}
      </ul>
    </Card>
  {/if}

  <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
    <Card title="Recent posts">
      {#if recent_posts.length === 0}
        <div class="text-center py-8">
          <Icon icon="mdi:pencil-outline" class="text-4xl text-secondary-300 mx-auto mb-3" />
          <p class="text-secondary-500 mb-4">No posts yet.</p>
          <Button href="/posts/new">Compose your first post</Button>
        </div>
      {:else}
        <ul class="flex flex-col divide-y divide-secondary-100">
          {#each recent_posts as post}
            <li class="py-3 first:pt-0 last:pb-0">
              <a use:inertia href={`/posts/${post.id}`} class="flex items-start justify-between gap-3 group">
                <span class="text-sm text-secondary-700 group-hover:text-primary-700">{post.body}</span>
                <StatusBadge status={post.status} />
              </a>
            </li>
          {/each}
        </ul>
      {/if}
    </Card>

    <Card title="Connected accounts">
      {#if social_accounts.length === 0}
        <div class="text-center py-8">
          <Icon icon="mdi:account-multiple-outline" class="text-4xl text-secondary-300 mx-auto mb-3" />
          <p class="text-secondary-500 mb-4">No accounts connected yet.</p>
          <Button href="/social_accounts/new">Connect your first account</Button>
        </div>
      {:else}
        <ul class="flex flex-col gap-2">
          {#each social_accounts as acc}
            <li class="flex items-center gap-2 text-sm">
              <PlatformBadge platform={acc.platform} handle={acc.handle} />
            </li>
          {/each}
        </ul>
      {/if}
    </Card>
  </div>
</AppLayout>
